import React from 'react';
import { getAvatarImage } from 'utils/avatars';
import './avatar.scss';

export type AvatarSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

interface AvatarProps {
  src?: string | null;
  alt?: string;
  name?: string;
  size?: AvatarSize;
  className?: string;
  border?: boolean;
  onClick?: () => void;
}

const Avatar: React.FC<AvatarProps> = ({ 
  src, 
  alt, 
  name = '', 
  size = 'md', 
  className = '',
  border = false,
  onClick 
}) => {
  // Tenta obter a imagem do avatar
  const avatarImage = src ? getAvatarImage(src) : undefined;
  
  // Gera iniciais do nome
  const getInitials = (name: string) => {
    if (!name) return 'U';
    
    const names = name.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };

  // Gera cor de fundo baseada no nome
  const getAvatarColor = (name: string) => {
    if (!name) return '#8b5cf6';
    
    const colors = [
      '#8b5cf6', '#06b6d4', '#10b981', '#f59e0b', 
      '#ef4444', '#ec4899', '#6366f1', '#84cc16'
    ];
    
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  const avatarClasses = [
    'avatar',
    `avatar-${size}`,
    border ? 'avatar-border' : '',
    onClick ? 'avatar-clickable' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={avatarClasses} onClick={onClick}>
      {avatarImage ? (
        <img src={avatarImage} alt={alt || name} className="avatar-image" />
      ) : (
        <div 
          className="avatar-initials"
          style={{ backgroundColor: getAvatarColor(name) }}
        >
          {getInitials(name)}
        </div>
      )}
    </div>
  );
};

export default Avatar;
